import { useState } from 'react'
import { Migrate_My_School_Class } from '@graphql/mutations'
import { useApi } from '@hooks/useApi'
import { mutate } from 'swr'
import { Books_Listing, Current_User, User_SchoolClasses } from '@graphql/queries'

const useMigrateMySchoolClass = () => {
  const [isPosting, setIsPosting] = useState(false)
  const { postMutation } = useApi()

  const post = async (data, successMessage, errorMessage) => {
    setIsPosting(true)

    const res = await postMutation(
      { input: { ...data } },
      Migrate_My_School_Class,
      successMessage,
      errorMessage,
      async () => {
        await mutate(Current_User)
        await mutate(User_SchoolClasses)
        await mutate(Books_Listing)
      }
    )

    setIsPosting(false)
    return res
  }

  return {
    post,
    isPosting,
  }
}

export { useMigrateMySchoolClass }
